import * as React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox } from '@fortawesome/free-solid-svg-icons';
import { observer } from 'mobx-react';
import { useSystem } from '../../../hooks/useSystem';
import { Font } from '../../../fonts';

export interface InboxIconWidgetProps {
  className?: any;
}

export const InboxIconWidget: React.FC<InboxIconWidgetProps> = observer((props) => {
  const system = useSystem();
  const notifications = system.session?.userNotificationEngine.notifications;
  const notification_count = notifications?.length || 0;

  return (
    <S.Container className={props.className}>
      <S.Icon $has_notifications={notification_count > 0} icon={faInbox} />
      {notification_count > 0 ? <S.Counter>{notification_count}</S.Counter> : null}
    </S.Container>
  );
});
namespace S {
  export const Container = styled.div`
    position: relative;
  `;

  export const Icon = styled(FontAwesomeIcon, {
    shouldForwardProp: (prop) => prop !== '$has_notifications'
  })<{ $has_notifications: boolean }>`
    color: ${(p) => (p.$has_notifications ? p.theme.text.primary : p.theme.text.secondary)};
    font-size: 25px;
    &:hover {
      opacity: 1;
    }
  `;

  const SIZE = 18;

  export const Counter = styled.div`
    background: red;
    color: white;
    font-family: ${Font.Normal};
    width: ${SIZE}px;
    height: ${SIZE}px;
    line-height: ${SIZE}px;
    border-radius: ${SIZE / 2}px;
    position: absolute;
    top: -5px;
    left: -5px;
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    vertical-align: middle;
  `;
}
